import { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { StringKey } from '../../../lang/index';
import { PublicStatusCard } from './public-status-card';

type BrokenLinkProps = {
  descriptionId: StringKey;
  titleId: StringKey;
  /** Interpolated into the description — the throttled state names the wait in minutes. */
  values?: Record<string, number | string>;
};

export const BrokenLink: FC<BrokenLinkProps> = ({ descriptionId, titleId, values }) => (
  <PublicStatusCard>
    <div className="flex flex-col items-center gap-3 text-center">
      <span className="text-xl font-semibold text-gray-700">
        <AppFormattedMessage id={titleId} />
      </span>
      <span className="text-sm font-[450] leading-5 text-gray-500">
        <AppFormattedMessage id={descriptionId} values={values} />
      </span>
    </div>
  </PublicStatusCard>
);
